import React, { useState, useEffect } from 'react';
import './ObjectVideos.css';

const ObjectVideos = ({ characterStyle, lowContrast, isInfo }) => {
  const [isLoaded1, setIsLoaded1] = useState(false);
  const [isLoaded2, setIsLoaded2] = useState(false);
  const [iField1Text, setIField1Text] = useState('');
  const [iField2Text, setIField2Text] = useState('');

  const videoSrc1 = `/characters/${characterStyle}/1.webm`;
  const videoSrc2 = `/characters/${characterStyle}/2.webm`;

  useEffect(() => {
    const updateTextFields = () => {
      switch (characterStyle) {
        case 'surferka':
          setIField1Text('Surferka Obiekt1');
          setIField2Text('Surferka Obiekt2');
          break;
        case 'powergirl':
          setIField1Text('Power Girl Obiekt1');
          setIField2Text('Power Girl Obiekt2');
          break;
        case 'aktywistka':
          setIField1Text('Aktywistka Obiekt1');
          setIField2Text('Aktywistka Obiekt2');
          break;
        case 'tatuazysta':
          setIField1Text('Twórca Obiekt1');
          setIField2Text('Twórca Obiekt2');
          break;
        default:
          setIField1Text('Default Obiekt1');
          setIField2Text('Default Obiekt2');
      }
    };

    updateTextFields();
  }, [characterStyle]);

  return (
    <div className={`video-container ${isInfo ? 'info' : 'noinfo'}`}>
      <video 
        id="video1" 
        className={`video1 ${lowContrast ? 'low-contrast' : 'normal-contrast'} ${isInfo ? 'info' : 'noinfo'}`}
        src={videoSrc1} 
        autoPlay 
        loop 
        muted 
        playsInline 
        onLoadedData={() => setIsLoaded1(true)} 
        onError={(e) => console.error('Error loading video 1:', e)}
        style={{ display: isLoaded1 ? 'block' : 'none' }}
      >
        Your browser does not support the video tag.
      </video>
      {isInfo && <div id="iField1" className='iField'><p>{iField1Text}</p></div>}
      <video 
        id="video2" 
        className={`video2 ${lowContrast ? 'low-contrast' : 'normal-contrast'} ${isInfo ? 'info' : 'noinfo'}`}
        src={videoSrc2} 
        autoPlay 
        loop 
        muted 
        playsInline 
        onLoadedData={() => setIsLoaded2(true)} 
        onError={(e) => console.error('Error loading video 2:', e)}
        style={{ display: isLoaded2 ? 'block' : 'none' }}
      >
        Your browser does not support the video tag.
      </video>
      {isInfo && <div id="iField2" className='iField'><p>{iField2Text}</p></div>}
    </div>
  );
};

export default ObjectVideos;
